(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("zh-CN", [], factory);
	else if(typeof exports === 'object')
		exports["zh-CN"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["zh-CN"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 